import { usePageContext } from "./PageContext";
import { Block } from "./Block";
import { ChildBlockProps } from "@softr-io/blocks-sdk/react";

export function ChildBlock({ definition, wrapperProps }: ChildBlockProps) {
    const { nestedBlocks } = usePageContext();
    // in fixed block roots mode, the block root is rendered by the `Block` component.
    // @see React18Block.tsx
    return (
        <Block
            definition={definition}
            childBlocks={nestedBlocks[definition.id] ?? EMPTY_OBJECT}
            topLevel={false}
            childBlockRootProps={wrapperProps}
        />
    );
}
const EMPTY_OBJECT = {} as const;
